












































































































import Vue from "vue";
import Component from "vue-class-component";
import EditableInput from "@/components/EditableInput.vue";
import EditableSelect from "@/components/EditableSelect.vue";
import KeyValue from "@/components/KeyValue.vue";
import {Device, DeviceBusEventData, DeviceConfigurationSet} from "@/types/core";
import {curDeviceService} from '@/services/DeviceService';
import {Prop} from "vue-property-decorator";
import * as _ from 'lodash';
import {DeviceCommandReq} from "@/services/CoreClient";
import DownlinksQueueSection from "@/components/device/DownlinksQueueSection.vue";
import {
  deviceConfigurationProfile,
} from "@/components/device/configuration/AbeewayProfile";
import ExpandButton from '@/components/ExpandButton.vue';
import GenericControl from "@/components/device/configuration/GenericControl.vue";
import {ConfigurationProfileHelper} from "@/components/device/configuration/ConfigurationProfileHelper";

@Component({
  components: {
    KeyValue,
    EditableInput,
    EditableSelect,
    DownlinksQueueSection,
    ExpandButton,
    GenericControl,
  }
})
export default class AbeewaySmartBadgeControl extends GenericControl {
  @Prop({ default: () => {}, type: Object}) device!:Device;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  error:string = '';

  configurationProfileHelper = new ConfigurationProfileHelper(deviceConfigurationProfile);
  currentConfiguration = this.configurationProfileHelper.getDeviceUIConfiguration();
  newConfiguration = this.configurationProfileHelper.getDeviceUIConfiguration();
  section = this.configurationProfileHelper.getUISections();

  created() {
    this.bus.$on('refresh-device', async (deviceBusEventData:DeviceBusEventData) => {
      await this.loadCurrentConfiguration();
    });
  }
  async mounted() {
    await this.loadCurrentConfiguration();
  }

  async requestConfiguration() {
    this.error = '';
    try {
      await curDeviceService.requestConfiguration({
        deviceId: this.device.deviceId,
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async updateConfiguration() {
    this.error = '';
    const formInvalid = _.some(_.keys(this.newConfiguration), id => ! this.isValueInRange(id, this.newConfiguration));
    if (formInvalid) {
      this.error = 'Some values on the form are invalid. Please fix them before submitting !';
      return;
    }

    const paramKeysToUpdate = _.filter(_.keys(this.newConfiguration),
        (key) => {
          if (typeof this.newConfiguration[key]!.value === "string" && typeof this.currentConfiguration[key]!.value === "object") {
            return this.newConfiguration[key]!.value !== '' && this.newConfiguration[key]!.value !== this.currentConfiguration[key]!.value.value
          } else {
            return this.newConfiguration[key]!.value !== this.currentConfiguration[key]!.value;
          }
        });

    if (paramKeysToUpdate.length > 0) {
      const params = _.map(paramKeysToUpdate, key => _.pick(this.newConfiguration[key]!, 'id', 'value'));
      try {
        await curDeviceService.sendDeviceCommand({
          deviceId: this.device.deviceId,
          command: 'set_configuration',
          params,
          updateConfiguration: true,
        } as DeviceCommandReq);
        this.bus.$emit('refresh');
      } catch (err) {
        this.error = (err as Error).message;
      }
    }
  }


  async loadCurrentConfiguration() {
    this.error = '';
    try {
      const reply = await curDeviceService.loadDeviceConfiguration({deviceId: this.device.deviceId}) as DeviceConfigurationSet;

      try {
        _.forEach(reply.newConf, param => {
          if (this.newConfiguration[this.toHex(param.id)]) {
            this.newConfiguration[this.toHex(param.id)]!.value = param.value;
          }
        });
      } finally {
      }

      try {
        _.forEach(reply.current, param => {
          if (this.currentConfiguration[this.toHex(param.id)]) {
            this.currentConfiguration[this.toHex(param.id)]!.value = param.value;
          }
        });
      } finally {
      }
    } catch (err) {
      console.log(`error: ${(err as Error).message}`);
    }
    try {
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  updateOption(id: string, value: string) {
    this.newConfiguration[id]!.value = value;
  }

  async playMelody() {
    this.error = '';
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'play_melody',
        params: [{
          id: 0x00,
          value: 0x03,
        }],
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async triggerHeartbeatMessage() {
    this.error = '';
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'trigger_heartbeat_message',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async resetDevice() {
    this.error = '';
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'reset',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async setSOSOn() {
    this.error = '';
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'sos_mode_on',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async setSOSOff() {
    this.error = '';
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'sos_mode_off',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async requestPosition() {
    this.error = '';
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'request_position',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }
}
